import api from '@/api'

export default {
// 나의 전자결재 가져오기
  getMyAPM(personCode: string, deptCode: string): Promise<any> {
    return api.get({
      url: `/workflow/document/api/count?personCode=${personCode}&deptCode=${deptCode}`,
    })
  },

  // EWS 데이터 가져오기
  getEWSData<TResult>(request: ewsRequest.request): Promise<TResult> {
    return api.post<TResult>({
      url: '/Mail/Dynamic/api/list',
      data: request,
    })
  },

  // 전자결재 데이터 가져오기
  getAPMList(documentQueryNumber: number, personCode: string, deptCode:string, startDate: string, endDate: string) {
    return api.post({
      url: '/workflow/document/api/list',
      data: {
        documentQueryNumber: Number(documentQueryNumber),
        personCode: personCode,
        deptCode: deptCode,
        itemsPerPage: 20,
        page: 1,
        searchType: -1,
        sortValue: 2,
        startDate: startDate,
        endDate: endDate,
      },
    })
  },

  // 설정된 배너목록(메인화면 배너 목록)
  getBannerList(comCode:string,isGlobal:boolean,mappingId?:string): Promise<webpartBanner.Banner[]>{
    return api.get({
      url:`/Webpart/WebpartBanner/api/getlist?comCode=${comCode}&isGlobal=${isGlobal}&mappingId=${mappingId}`
    })
  },

  // BetterKolmar 메일 수신자 목록
  getReceiversList(roleType:string, comCode: string){
    return api.get({
      url: `/Common/Role/api/roletype?RoleType=${roleType}&ComCode=${comCode}`
    })
  }
}